import type {TooltipProps} from '@mui/material/Tooltip'
import React from 'react'

export interface CellTooltipPlacement {
  placement?: TooltipProps['placement']
  offset?: [number, number] // [skid, distance]
}

export interface TableHeadCell<T> {
  id: Extract<keyof T, string>
  label: React.ReactNode
  tooltip?: React.ReactNode
  render: (row: T) => React.ReactNode
  search?: (row: T, id: Extract<keyof T, string>, searchTerm: string) => boolean
  maxWidth?: number
  minWidth?: number
  cellTooltip?: (row: T) => string | undefined
  cellTooltipPlacement?: CellTooltipPlacement
  disableRowLink?: boolean // opt-out this column from the full-cell row link/overlay

  // Marks columns that are optional/extra so the table can style them differently.
  isExtra?: boolean
}

export const defaultSearch = <T>(row: T, id: Extract<keyof T, string>, searchTerm: string): boolean => {
  if (typeof row[id] === 'object') {
    return JSON.stringify(row[id]).toLowerCase().includes(searchTerm.toLowerCase())
  }

  return String(row[id]).toLowerCase().includes(searchTerm.toLowerCase())
}
